import { Text } from "@chakra-ui/react";

import { UUID } from "foundation-ts/types";
import { $ok } from "foundation-ts/commons";
import { CloudSubscriptionDto, UserDto } from "doxecure-commons/lib/doxecureClientTypes";

import { CloudCard } from "@components/Cards/CloudCard";
import { SeaShellBox } from "@components/SeaShellBox";
import { SectionBox } from "@components/SectionBox/SectionBox";
import { SectionBoxFooter } from "@components/SectionBox/SectionBoxFooter";
import { useStyles } from "@hooks/useStyles";

interface CloudSubscriptionsBoxProps {
    userProfile:UserDto;
    onRemove: (userChannelId: UUID) => void;
    onAdd: () => void;
}

export const CloudSubscriptionsBox = (props: CloudSubscriptionsBoxProps) => {
    const { userProfile, onAdd, onRemove } = props;
    const { sectionStyle, itemStyle } = useStyles();

    const renderCloudCard = (item: CloudSubscriptionDto) => {
        return (<CloudCard
            key={item.apid}
            itemStyle={itemStyle.cloud}
            item={item}
            onClick={() => onRemove(item.apid)}
        />)
    };

    const renderAddCloudButton = () => {
        return <SectionBoxFooter component="clouds" title="Se connecter à un cloud" onClick={onAdd} /> ;
    } ;

    // TODO Ajouter des skeletons
    // TODO: verify that we can connect to clouds here even if we have no cloud available

    return (
        <SeaShellBox component="form">
            <Text width="100%" fontWeight="bold">Abonnement Cloud</Text>

            {$ok(userProfile.cloudSubscriptions) && (
                <SectionBox
                    items={userProfile.cloudSubscriptions}
                    sectionStyle={sectionStyle.clouds}
                    renderItem={renderCloudCard}
                    renderFooter={renderAddCloudButton}
                />
            )}
        </SeaShellBox>
    );
};
